import type { ObjectValues } from '@beyonnex/bx-angular-ui';
import type { ResolvedGeoLocation } from '../../../models/foundation.models';

export const GEO_LOCATION_SUBJECT = {
  PROPERTY: 'property',
  BUILDING: 'building',
} as const;
export type GeoLocationSubject = ObjectValues<typeof GEO_LOCATION_SUBJECT>;

export interface GeoLocationModalData {
  thingId: string;
  subject: GeoLocationSubject;
  address: string;
  geoLocation: ResolvedGeoLocation;
  canEdit: boolean;
}
